import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth, roleHome } from "./context/AuthContext";
import { ChildThemeProvider } from "./context/ThemeContext";
import { ReadAloudProvider } from "./context/ReadAloudContext";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Verify from "./pages/Verify";
import Pricing from "./pages/Pricing";
import PaymentSuccess from "./pages/PaymentSuccess";
import ChildDashboard from "./pages/child/ChildDashboard";
import ExercisePlayer from "./pages/child/ExercisePlayer";
import Leaderboard from "./pages/child/Leaderboard";
import Shop from "./pages/child/Shop";
import TafelSprint from "./pages/child/TafelSprint";
import Journey from "./pages/child/Journey";
import RaceGame from "./pages/child/RaceGame";
import Wereldreis from "./pages/child/Wereldreis";
import WorldMapGame from "./pages/child/WorldMapGame";
import FlagQuiz from "./pages/child/FlagQuiz";
import Passport from "./pages/child/Passport";
import Tafeltoets from "./pages/child/Tafeltoets";
import RumiParty from "./pages/child/RumiParty";
import Mastermind from "./pages/child/Mastermind";
import Speelhoek from "./pages/child/Speelhoek";
import Vogelvlucht from "./pages/child/Vogelvlucht";
import Dinorace from "./pages/child/Dinorace";
import Digger from "./pages/child/Digger";
import AlleyCat from "./pages/child/AlleyCat";
import ParentDashboard from "./pages/parent/ParentDashboard";
import AdminPanel from "./pages/admin/AdminPanel";
import { ImpersonationBanner } from "./components/common/ImpersonationBanner";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-12 h-12 rounded-full border-4 border-primary/30 border-t-primary animate-spin" />
    </div>
  );
}

function Protected({ role, children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  const allowed = Array.isArray(role) ? role : role ? [role] : null;
  if (allowed && !allowed.includes(user.role)) return <Navigate to={roleHome(user.role)} replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <ImpersonationBanner />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/prijzen" element={<Pricing />} />
          <Route path="/betaling-succes" element={<PaymentSuccess />} />
          <Route path="/leerling" element={<Protected role="child"><ChildThemeProvider><ChildDashboard /></ChildThemeProvider></Protected>} />
          <Route path="/leerling/oefening" element={<Protected role="child"><ChildThemeProvider><ReadAloudProvider><ExercisePlayer /></ReadAloudProvider></ChildThemeProvider></Protected>} />
          <Route path="/leerling/scorebord" element={<Protected role="child"><ChildThemeProvider><Leaderboard /></ChildThemeProvider></Protected>} />
          <Route path="/leerling/winkel" element={<Protected role="child"><ChildThemeProvider><Shop /></ChildThemeProvider></Protected>} />
          <Route path="/leerling/sprint" element={<Protected role="child"><ChildThemeProvider><TafelSprint /></ChildThemeProvider></Protected>} />
          <Route path="/leerling/avontuur" element={<Protected role="child"><ChildThemeProvider><Journey /></ChildThemeProvider></Protected>} />
          <Route path="/leerling/race" element={<Protected role="child"><ChildThemeProvider><RaceGame /></ChildThemeProvider></Protected>} />
          <Route path="/leerling/wereldreis" element={<Protected role="child"><ChildThemeProvider><Wereldreis /></ChildThemeProvider></Protected>} />
          <Route path="/leerling/wereldreis/kaart" element={<Protected role="child"><ChildThemeProvider><WorldMapGame /></ChildThemeProvider></Protected>} />
          <Route path="/leerling/wereldreis/vlaggen" element={<Protected role="child"><ChildThemeProvider><FlagQuiz /></ChildThemeProvider></Protected>} />
          <Route path="/leerling/paspoort" element={<Protected role="child"><ChildThemeProvider><Passport /></ChildThemeProvider></Protected>} />
          <Route path="/leerling/tafeltoets" element={<Protected role="child"><ChildThemeProvider><Tafeltoets /></ChildThemeProvider></Protected>} />
          <Route path="/leerling/rumi-feest" element={<Protected role="child"><ChildThemeProvider><RumiParty /></ChildThemeProvider></Protected>} />
          <Route path="/leerling/codekraker" element={<Protected role="child"><ChildThemeProvider><Mastermind /></ChildThemeProvider></Protected>} />
          <Route path="/leerling/speelhoek" element={<Protected role="child"><ChildThemeProvider><Speelhoek /></ChildThemeProvider></Protected>} />
          <Route path="/leerling/vogelvlucht" element={<Protected role="child"><ChildThemeProvider><Vogelvlucht /></ChildThemeProvider></Protected>} />
          <Route path="/leerling/dinorace" element={<Protected role="child"><ChildThemeProvider><Dinorace /></ChildThemeProvider></Protected>} />
          <Route path="/leerling/digger" element={<Protected role="child"><ChildThemeProvider><Digger /></ChildThemeProvider></Protected>} />
          <Route path="/leerling/alley" element={<Protected role="child"><ChildThemeProvider><AlleyCat /></ChildThemeProvider></Protected>} />
          <Route path="/ouder" element={<Protected role={["parent", "admin"]}><ParentDashboard /></Protected>} />
          <Route path="/admin" element={<Protected role="admin"><AdminPanel /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
